import React from "react";
import classNames from "classnames";

export default function Dropdown({ placeholder, value, options, onChange }) {
  return (
    <span className="ml-1 relative rounded-md shadow-sm text-gray-700 hover:text-gray-500 transition ease-in-out duration-150">
      <select
        value={value || ""}
        onChange={onChange}
        className={classNames(
          "cursor-pointer appearance-none inline-flex justify-center w-full rounded-md border-2 border-gray-300 pl-2 pr-6 py-1 bg-white text-sm leading-5 font-medium focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
        )}
        style={{ width: 70 }}
      >
        <option value="" disabled selected hidden>
          {placeholder}
        </option>
        {(options || []).map((o) => (
          <option key={o}>{o}</option>
        ))}
      </select>
      <svg
        className="absolute h-5 w-5 select-none pointer-events-none"
        style={{ right: 6, top: 4 }}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </span>
  );
}
